// extracted by mini-css-extract-plugin
export var cardHeader = "_hx-1";
export var contentCard = "_hx-0";
export var headerActions = "_hx-3";
export var reorderHandle = "_hx-5";
export var titleArea = "_hx-2";
export var titleAreaWithHandle = "_hx-4";